module.exports = __webpack_public_path__ + "static/marut-mtg_clb-9dba77ff03976d695dfd6ea0ceb7eabf.jpg";